import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["legendText"];
// @flow

/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Settings16 } from '@carbon/icons-react';
import { Button } from 'carbon-components-react';
import cx from 'classnames';
import RowSizeRadioGroup from './RowSizeRadioGroup';
import { pkg } from '../../../../../settings';
var blockClass = "".concat(pkg.prefix, "--datagrid");

var RowSizeDropdown = function RowSizeDropdown(_ref) {
  var _ref$legendText = _ref.legendText,
      legendText = _ref$legendText === void 0 ? 'Row height' : _ref$legendText,
      props = _objectWithoutProperties(_ref, _excluded);

  var buttonRef = React.useRef({});

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    hasIconOnly: true,
    ref: buttonRef,
    kind: "ghost",
    tooltipPosition: "left",
    renderIcon: Settings16,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    iconDescription: legendText,
    className: cx("".concat(blockClass, "__row-size-button"), _defineProperty({}, "".concat(blockClass, "__row-size-button--open"), isOpen))
  }), isOpen && /*#__PURE__*/React.createElement(RowSizeRadioGroup, _extends({}, props, {
    legendText: legendText,
    buttonRef: buttonRef,
    hideRadioGroup: function hideRadioGroup() {
      setIsOpen(false);
    }
  })));
};

RowSizeDropdown.propTypes = {
  datagridName: PropTypes.string,
  legendText: PropTypes.string,
  light: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  selectedOption: PropTypes.string
};
export default RowSizeDropdown;